import { render } from "./ManagerBox.vue?vue&type=template&id=52382e48&scoped=true"
import script from "./ManagerBox.vue?vue&type=script&lang=js"
export * from "./ManagerBox.vue?vue&type=script&lang=js"

import "./ManagerBox.vue?vue&type=style&index=0&id=52382e48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52382e48"]])

export default __exports__